var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#CA024F",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M17 5V4a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v1M1 5h22m-8 6v5m-6-5v5M3 5h18l-.663 13.25A5 5 0 0 1 15.344 23H8.656a5 5 0 0 1-4.994-4.75z"
  })));
};
export default SvgDelete;